import React from "react";
import { Heading, Text, HStack, VStack, Divider } from "@astryxdesign/core";
import styles from "./SectionHeader.module.css";

export interface SectionHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

/**
 * Sub-page section header using Astryx's Heading/Text/Divider.
 *
 * One level below PageHeader (level=2 heading), for parallel sections within
 * a single-scroll page (e.g. "Details" / "Interview script"). `action` sits
 * at the end of the header row — typically a count Badge. A hairline
 * Divider closes out the header.
 *
 * Title/description come from Astryx Heading/Text, so this MUST be rendered
 * inside an Astryx <Theme> scope.
 */
const SectionHeader = ({
  title,
  description,
  action,
}: SectionHeaderProps): React.ReactElement => {
  return (
    <section className={styles.header}>
      <HStack justify="between" align="center" gap={3}>
        <VStack gap={1}>
          <Heading level={2}>{title}</Heading>
          {description && <Text color="secondary">{description}</Text>}
        </VStack>
        {action}
      </HStack>
      <Divider />
    </section>
  );
};

export default SectionHeader;
